import { render } from "./Generic.vue?vue&type=template&id=2c034aac"
import script from "./Generic.vue?vue&type=script&lang=js"
export * from "./Generic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__